import { toast } from 'react-toastify'
import { ReadonlyURLSearchParams } from 'next/navigation'

import {
  Simulation,
  ValidatedSimulation,
  ValidationResult
} from './useCreateSimulation.types'
import { CreateSimulationPayload } from '@/modules/simulator/api'
import { getTrackingInfoUtms } from '@/modules/simulator/functions'
import { getAnonymousId } from '@/global/utils'
import {
  addError,
  Context,
  SimulatorCode
} from '@/global/plugins/observability'

const validateProps = (simulation: Simulation): ValidationResult => {
  if (
    simulation.companyEmployees &&
    simulation.companyCity &&
    simulation.companyCnpj &&
    simulation.responsibleName &&
    simulation.responsiblePhone &&
    simulation.responsibleEmail
  )
    return {
      isValid: true,
      data: {
        ...simulation,
        companyEmployees: simulation.companyEmployees,
        companyCity: simulation.companyCity,
        companyCnpj: simulation.companyCnpj,
        responsibleName: simulation.responsibleName,
        responsiblePhone: simulation.responsiblePhone,
        responsibleEmail: simulation.responsibleEmail
      }
    }

  return { isValid: false }
}

const buildPayload = (
  simulation: ValidatedSimulation,
  searchParams?: ReadonlyURLSearchParams | null
): CreateSimulationPayload => {
  return {
    ...simulation,
    trackingInfo: {
      ...(searchParams ? getTrackingInfoUtms(searchParams) : {}),
      anonymousId: getAnonymousId() || ''
    }
  }
}

const handleError = (error: Error, code: SimulatorCode, message: string) => {
  addError({
    error,
    data: {
      context: Context.SIMULATOR,
      code,
      message,
      location: 'useCreateSimulation'
    }
  })

  toast('Ops! Tivemos um problema. Tente novamente mais tarde')
}

export { validateProps, buildPayload, handleError }
